import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useModalStore from '@/stores/modal/modalStore';
import { useUserStore } from '@/stores/user/userStore';
import { getUserCredits } from '@/services/user.service';

const CREDITS_POLL_INTERVAL = 30000; // Poll every 30 seconds

const RouteChangeHandler = () => {
  const location = useLocation();
  const closePlansModal = useModalStore(state => state.closePlansModal);
  const setCredits = useUserStore(state => state.setCredits);
  const accessToken = useUserStore(state => state.auth?.access_token);
  const pollIntervalRef = useRef(null);

  // Close modals on route change
  useEffect(() => {
    closePlansModal();
  }, [location.pathname, closePlansModal]);

  // Fetch credits helper
  const fetchCredits = () => {
    if (!accessToken) return;
    getUserCredits()
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setCredits(response.data);
        }
      })
      .catch(() => {});
  };

  // Fetch credits immediately on route change + poll periodically
  useEffect(() => {
    fetchCredits();

    // Start polling so credits stay fresh even without navigation
    pollIntervalRef.current = setInterval(fetchCredits, CREDITS_POLL_INTERVAL);

    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
      }
    };
  }, [location.pathname, setCredits, accessToken]);

  return null;
};

export default RouteChangeHandler;
